import { ElementRef, NgZone, TemplateRef } from '@angular/core';
import { SessionService } from '../../session/session.service';
import { MessageService } from '../../message/message.service';
import { HttpResponse } from '@angular/common/http';
import { SessionStorageService } from 'ngx-webstorage';
import { ActionPlanService } from '../../action-plan/action-plan.service';
import { Session } from '../../../shared/model/session.model';
import { TrackerService } from '../../../core/tracker/tracker.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RatingService } from '../../rating/rating.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../../core/user/user.service';
import { SessionChatComponent } from '../../session/session-chat-coach/session-chat.component';
import { debug } from '../../../app.constants';
import moment from "moment";
import { RateSessionComponent } from '../../../shared/rate/rate-session.component';
import { NavbarInukaService } from '../../navbar-inuka/navbar-inuka.service';
import { VideoCallService } from '../../video-call/video-call.service';
import { FlowManagerService } from '../../../core/util/flow-manager.service';
import { SessionTimeUtils } from '../../../core/util/SessionTimeUtils';
import { JhiAlertService, JhiEventManager } from '../../../ng-jhipster/service';
import { JhiLanguageService } from '../../../ng-jhipster/language';
import * as i0 from "@angular/core";
import * as i1 from "../../action-plan/action-plan.service";
import * as i2 from "../../session/session.service";
import * as i3 from "../../message/message.service";
import * as i4 from "ngx-webstorage";
import * as i5 from "../../rating/rating.service";
import * as i6 from "../../../ng-jhipster/service";
import * as i7 from "../../../core/tracker/tracker.service";
import * as i8 from "@angular/router";
import * as i9 from "@ng-bootstrap/ng-bootstrap";
import * as i10 from "../../../core/user/user.service";
import * as i11 from "../../../ng-jhipster/language";
import * as i12 from "../../navbar-inuka/navbar-inuka.service";
import * as i13 from "../../video-call/video-call.service";
import * as i14 from "../../../core/util/flow-manager.service";
import * as i15 from "@angular/common";
import * as i16 from "../../../shared/alert/alert.component";
import * as i17 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i18 from "@angular/material/tooltip";
import * as i19 from "../chat-ui-new/chat-ui-new.component";
import * as i20 from "./session-info-header/session-info-header.component";
import * as i21 from "@fortawesome/angular-fontawesome";
import * as i22 from "../chat-ui/message-send/session-message-send.component";
import * as i23 from "../../action-plan/action-plan/action-plan.component";
import * as i24 from "../../../shared/modal-success/modal-success.component";
import * as i25 from "@ngx-translate/core";
const _c0 = ["rateSessionModal"];
const _c1 = ["sessionDoesNotExistModal"];
function SessionChatUserComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "button", 10);
    i0.ɵɵlistener("click", function SessionChatUserComponent_div_3_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.switchToChat(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelementStart(4, "button", 11);
    i0.ɵɵlistener("click", function SessionChatUserComponent_div_3_Template_button_click_4_listener() { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(); return ctx_r8.switchToActionPlan(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r0.getChatButtonColor());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", ctx_r0.getActionPlanButtonColor());
} }
function SessionChatUserComponent_div_5_session_info_header_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "session-info-header", 30);
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("session", ctx_r11.session)("sessionStartTime", ctx_r11.sessionStartTime)("onActionPlan", false)("displaySessionInfoHeader", ctx_r11.displaySessionInfoHeader !== false);
} }
const _c2 = function (a0) { return { "rating-star-hover": a0 }; };
function SessionChatUserComponent_div_5_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelement(1, "fa-icon", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r17 = ctx.index;
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c2, i_r17 <= ctx_r13.maxHighLightIndexCoach));
} }
function SessionChatUserComponent_div_5_session_message_send_19_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "session-message-send", 33);
    i0.ɵɵlistener("focusIn", function SessionChatUserComponent_div_5_session_message_send_19_Template_session_message_send_focusIn_0_listener() { i0.ɵɵrestoreView(_r19); const ctx_r18 = i0.ɵɵnextContext(2); return ctx_r18.onMessageSendTextboxFocusIn(); })("focusOut", function SessionChatUserComponent_div_5_session_message_send_19_Template_session_message_send_focusOut_0_listener() { i0.ɵɵrestoreView(_r19); const ctx_r20 = i0.ɵɵnextContext(2); return ctx_r20.onMessageSendTextboxFocusOut(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("session", ctx_r15.session)("maxCharacterSize", 3000)("messageToBeReplied", ctx_r15.messageToBeReplied);
} }
const _c3 = function (a0) { return { "col-md-12 col-lg-8": a0 }; };
const _c4 = function (a0) { return { "background-color": a0 }; };
const _c5 = function (a0) { return { height: a0 }; };
function SessionChatUserComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r22 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12, 13);
    i0.ɵɵelementStart(2, "div", 14, 15);
    i0.ɵɵtemplate(4, SessionChatUserComponent_div_5_session_info_header_4_Template, 1, 4, "session-info-header", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 17, 18);
    i0.ɵɵelementStart(7, "div", 19);
    i0.ɵɵelementStart(8, "div", 20);
    i0.ɵɵelement(9, "input", 21);
    i0.ɵɵelementStart(10, "div", 22);
    i0.ɵɵtemplate(11, SessionChatUserComponent_div_5_div_11_Template, 2, 3, "div", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 24);
    i0.ɵɵelementStart(13, "h4", 25);
    i0.ɵɵlistener("click", function SessionChatUserComponent_div_5_Template_h4_click_13_listener() { i0.ɵɵrestoreView(_r22); const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.openRateSession(); });
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 26);
    i0.ɵɵelementStart(16, "chat-ui-new", 27);
    i0.ɵɵlistener("repliedMessage", function SessionChatUserComponent_div_5_Template_chat_ui_new_repliedMessage_16_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.repliedMessage($event); })("firstSessionMessageOutput", function SessionChatUserComponent_div_5_Template_chat_ui_new_firstSessionMessageOutput_16_listener($event) { i0.ɵɵrestoreView(_r22); const ctx_r24 = i0.ɵɵnextContext(); return ctx_r24.firstSessionMessageOutput($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", null, 28);
    i0.ɵɵtemplate(19, SessionChatUserComponent_div_5_session_message_send_19_Template, 1, 3, "session-message-send", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r9 = i0.ɵɵreference(1);
    const _r10 = i0.ɵɵreference(3);
    const _r12 = i0.ɵɵreference(6);
    const _r14 = i0.ɵɵreference(18);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(22, _c3, !ctx_r1.isEmbed))("ngStyle", i0.ɵɵpureFunction1(24, _c4, (ctx_r1.session == null ? null : ctx_r1.session.ended) ? "rgb(237,237,237)" : "white"));
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("d-lg-none", !ctx_r1.isEmbed);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.session && ctx_r1.session.coach && !ctx_r1.displayingPastSession);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r1.displayingPastSession ? "d-block" : "d-none");
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r1.stars);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("jhiTranslate", ctx_r1.currentRating ? "sessionChat.button.editFeedback" : "sessionChat.button.leaveFeedback")("matTooltip", i0.ɵɵpipeBind1(14, 20, "sessionChat.button.feedbackTooltip"))("matTooltipPosition", "below")("matTooltipClass", "feedback-tool-tip");
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("chat-container", !ctx_r1.isEmbed)("chat-container-embed", ctx_r1.isEmbed);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(26, _c5, _r9.offsetHeight - _r12.offsetHeight - _r10.offsetHeight - _r14.offsetHeight + "px"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("session", ctx_r1.session)("displayingPastSession", ctx_r1.displayingPastSession)("viewportHeight", ctx_r1.viewportHeight ? ctx_r1.viewportHeight : "100%");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.displayingPastSession);
} }
function SessionChatUserComponent_div_6_button_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "button", 38);
} }
function SessionChatUserComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelementStart(1, "div", 35);
    i0.ɵɵtemplate(2, SessionChatUserComponent_div_6_button_2_Template, 1, 0, "button", 36);
    i0.ɵɵelement(3, "action-plan", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(3, _c4, (ctx_r2.session == null ? null : ctx_r2.session.ended) ? "rgb(237,237,237)" : "white"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r2.upcomingSessions == null ? null : ctx_r2.upcomingSessions.length) === 0 && (ctx_r2.session == null ? null : ctx_r2.session.active) && (ctx_r2.session == null ? null : ctx_r2.session.started));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("actionPlan", ctx_r2.actionPlan);
} }
function SessionChatUserComponent_div_7_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelement(1, "session-info-header", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("session", ctx_r26.session)("sessionStartTime", ctx_r26.sessionStartTime)("onActionPlan", true)("displaySessionInfoHeader", ctx_r26.displaySessionInfoHeader !== false);
} }
function SessionChatUserComponent_div_7_button_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "button", 44);
} }
function SessionChatUserComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 39);
    i0.ɵɵtemplate(1, SessionChatUserComponent_div_7_div_1_Template, 2, 4, "div", 40);
    i0.ɵɵelementStart(2, "div", 41);
    i0.ɵɵtemplate(3, SessionChatUserComponent_div_7_button_3_Template, 1, 0, "button", 42);
    i0.ɵɵelement(4, "action-plan", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.sessionId && ctx_r3.session && ctx_r3.session.coach && !ctx_r3.displayingPastSession);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r3.upcomingSessions == null ? null : ctx_r3.upcomingSessions.length) === 0 && (ctx_r3.session == null ? null : ctx_r3.session.active) && (ctx_r3.session == null ? null : ctx_r3.session.started));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("actionPlan", ctx_r3.actionPlan);
} }
function SessionChatUserComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "modal-success", 45);
    i0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    i0.ɵɵproperty("message", i0.ɵɵpipeBind1(1, 2, "sessionChat.messages.active"))("navigateTo", "index-user");
} }
export class SessionChatUserComponent extends SessionChatComponent {
    constructor(actionPlanService, sessionService, messageService, sessionStorage, ratingService, alertService, trackerService, router, route, modalService, ngZone, elementRef, userService, languageService, navbarInukaService, eventManager, videoCallService, flowManagerService) {
        super(messageService, alertService, sessionStorage, sessionService, modalService, ngZone);
        this.actionPlanService = actionPlanService;
        this.sessionService = sessionService;
        this.messageService = messageService;
        this.sessionStorage = sessionStorage;
        this.ratingService = ratingService;
        this.alertService = alertService;
        this.trackerService = trackerService;
        this.router = router;
        this.route = route;
        this.modalService = modalService;
        this.ngZone = ngZone;
        this.elementRef = elementRef;
        this.userService = userService;
        this.languageService = languageService;
        this.navbarInukaService = navbarInukaService;
        this.eventManager = eventManager;
        this.videoCallService = videoCallService;
        this.flowManagerService = flowManagerService;
        this.isEmbed = false;
        this._sessionId = null;
        this.firstSessionMessage = null;
        this.stars = [1, 2, 3, 4, 5];
        this.currentRating = undefined;
    }
    set sessionId(value) {
        this._sessionId = value;
        console.log(value);
        debug("sessionId: " + value, "SessionChatUserComponent");
        this.loadSession();
    }
    get sessionId() {
        return this._sessionId;
    }
    ngOnInit() {
        this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#F7F4EB';
        if (!this.isEmbed) {
            this.navbarInukaService.hideEmbeddedComponent();
        }
        const sessionId = this.route.snapshot.params["sessionId"];
        if (sessionId) {
            this.sessionId = sessionId;
        }
        this.displayingPastSession = this.route.snapshot.params["past"] === 'past';
        console.log(this.displayingPastSession);
        this.subscribeToWebsocket();
        this.url = this.router.url;
        this.sessionService.futureSession().subscribe((res) => this.upcomingSessions = res.body || [], () => console.log("Future session can not be retrieved."));
    }
    loadSession() {
        // get current session and coach data
        // get past messages
        if (this.sessionId) {
            this.messageService.getSession(this.sessionId).subscribe(res => this.onSuccess(res.body), err => this.onError(err));
        }
    }
    subscribeToWebsocket() {
        this.listenerObjectSubscription = this.trackerService.listenerSubject.subscribe(value => {
            var _a;
            const message = value['body'];
            const type = value['type'];
            if (this.displayingPastSession) {
                return;
            }
            if (type === 'SESSION_STATUS_CHANGED') {
                let s = message;
                console.log('subscribeToWebsocket: SESSION_STATUS_CHANGED: ' + JSON.stringify(s));
                if (s.ended) {
                    console.log("Display rate session modal");
                    Session.changeStatusOfSessionToEnded(this.session);
                    const modalRef = this.modalService.open(RateSessionComponent, { size: 'lg', backdrop: 'static' });
                    modalRef.componentInstance.session = this.session;
                }
                else {
                    console.log("current session status: " + this.session.statusOfSession + ", new session status: " + s.statusOfSession);
                }
            }
            else if (type === 'WELLBEING_PLAN_UPDATED') {
                this.fetchActiveActionPlan();
            }
            else if (type === 'SESSION_EXTENDED') {
                this.session.duration = message['duration'];
                this.updateMinutesLeft();
            }
            else if (type === 'VIDEO_CALL_STARTED') {
                let s = message;
                if ((s === null || s === void 0 ? void 0 : s.id) === ((_a = this.session) === null || _a === void 0 ? void 0 : _a.id)) {
                    // coach initiated a video call
                    this.router.navigate(['/session/video', this.session.id]).then();
                }
            }
            else {
                // console.log('SessionChatUserComponent ignoring ' + type + ' message');
            }
        });
    }
    onSuccess(body) {
        var _a, _b;
        this.session = body;
        this.sessionStartTime = moment((_a = this.session) === null || _a === void 0 ? void 0 : _a.sessionStartTime).format('hh:mm a');
        this.user = this.session.user;
        this.coach = this.session.coach;
        this.langKey = this.languageService.getCurrentLanguage();
        this.updateMinutesLeftRecurring(1);
        this.fetchActiveActionPlan();
        this.ratingService.findBySessionId((_b = this.session) === null || _b === void 0 ? void 0 : _b.id).subscribe(res => {
            this.currentRating = res.body || null;
            this.maxHighLightIndexCoach = this.currentRating ? this.currentRating.rating - 1 : -1;
            this.checkToShowSubmitRatingPopup(this.session, this.currentRating);
        });
        this.ratingSubscription = this.eventManager.subscribe('ratingModifications', () => {
            var _a;
            this.ratingService.findBySessionId((_a = this.session) === null || _a === void 0 ? void 0 : _a.id).subscribe(res => {
                this.currentRating = res.body || null;
                this.maxHighLightIndexCoach = this.currentRating ? this.currentRating.rating - 1 : -1;
            });
        });
        localStorage.setItem('coachName', this.coach.login); // added for old session-schedule, consider removing it after session schedule page migration
    }
    checkToShowSubmitRatingPopup(session, currentRating) {
        if ((session === null || session === void 0 ? void 0 : session.ended) && session.attendanceType === 'ALL_ATTENDED' && !currentRating) {
            // if there is no session summary
            if (SessionTimeUtils.calculateMinutesPassedFromSessionEndTime(session) <= 60) {
                this.openRateSession();
            }
        }
    }
    onError(err) {
        console.log('error occured: ' + JSON.stringify(err.status));
        if (err.status === 404) {
            this.modalService.open(this.sessionDoesNotExistModal);
        }
    }
    fetchActiveActionPlan() {
        this.actionPlanService.findBySessionId(this.session.id).subscribe((res) => {
            this.actionPlan = res.body;
        }, err => console.log(err.message));
    }
    displayCountdownModal() { }
    repliedMessage(message) {
        this.messageToBeReplied = message;
        console.log(this.messageToBeReplied);
    }
    switchToChat() {
        this.switchTo = 'chat';
    }
    switchToActionPlan() {
        this.switchTo = 'action plan';
        this.messageToBeReplied = null;
    }
    getChatButtonColor() {
        let result;
        if (this.switchTo === 'chat')
            result = 'btn-primary';
        else
            result = 'btn-secondary';
        return result;
    }
    getActionPlanButtonColor() {
        let result;
        if (this.switchTo === 'action plan')
            result = 'btn-primary';
        else
            result = 'btn-secondary';
        return result;
    }
    firstSessionMessageOutput(message) {
        if (message != null) {
            if (this.firstSessionMessage === null || this.firstSessionMessage.id !== message.id) {
                this.firstSessionMessage = message;
                this.getActionPlan(this.firstSessionMessage.sessionId);
            }
        }
    }
    getActionPlan(sessionId) {
        if (sessionId === this.session.id) { // make sure we are going to fetch the right action plan
            this.actionPlanService.findBySessionId(sessionId).subscribe((res) => {
                this.actionPlan = res.body;
            });
        }
    }
    ngOnDestroy() {
        if (this.updateMinutesLeftRecurringHandle) {
            clearInterval(this.updateMinutesLeftRecurringHandle);
        }
        if (this.listenerObjectSubscription) {
            this.listenerObjectSubscription.unsubscribe();
        }
        if (this.routeSubscription) {
            this.routeSubscription.unsubscribe();
        }
        if (this.ratingSubscription) {
            this.ratingSubscription.unsubscribe();
        }
    }
    onMessageSendTextboxFocusIn() {
        if (!this.isScreenLg) {
            this.eventManager.broadcast('collapsedModeEnabled');
        }
    }
    onMessageSendTextboxFocusOut() {
        if (!this.isScreenLg) {
            this.eventManager.broadcast('collapsedModeDisabled');
        }
    }
    openRateSession() {
        const modalRef = this.modalService.open(RateSessionComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.session = this.session;
    }
    onKeyupHandler(event) {
        this.isKeyPressed = true;
    }
    isYourSessionStarted() {
        return !this.isEmbed &&
            !this.displayingPastSession &&
            this.session &&
            this.session.minutesLeftToSessionEnd > 0 &&
            this.session.minutesLeftToSessionStart <= 10 &&
            !this.isKeyPressed;
    }
    isSessionStarted() {
        return !this.isEmbed &&
            !this.displayingPastSession &&
            this.session &&
            this.session.minutesLeftToSessionEnd > 0 &&
            this.session.minutesLeftToSessionStart <= 10 &&
            this.isKeyPressed;
    }
}
SessionChatUserComponent.ɵfac = function SessionChatUserComponent_Factory(t) { return new (t || SessionChatUserComponent)(i0.ɵɵdirectiveInject(i1.ActionPlanService), i0.ɵɵdirectiveInject(i2.SessionService), i0.ɵɵdirectiveInject(i3.MessageService), i0.ɵɵdirectiveInject(i4.SessionStorageService), i0.ɵɵdirectiveInject(i5.RatingService), i0.ɵɵdirectiveInject(i6.JhiAlertService), i0.ɵɵdirectiveInject(i7.TrackerService), i0.ɵɵdirectiveInject(i8.Router), i0.ɵɵdirectiveInject(i8.ActivatedRoute), i0.ɵɵdirectiveInject(i9.NgbModal), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i10.UserService), i0.ɵɵdirectiveInject(i11.JhiLanguageService), i0.ɵɵdirectiveInject(i12.NavbarInukaService), i0.ɵɵdirectiveInject(i6.JhiEventManager), i0.ɵɵdirectiveInject(i13.VideoCallService), i0.ɵɵdirectiveInject(i14.FlowManagerService)); };
SessionChatUserComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SessionChatUserComponent, selectors: [["session-chat-user"]], viewQuery: function SessionChatUserComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rateSessionModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sessionDoesNotExistModal = _t.first);
    } }, hostBindings: function SessionChatUserComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("keyup", function SessionChatUserComponent_keyup_HostBindingHandler($event) { return ctx.onKeyupHandler($event); }, false, i0.ɵɵresolveDocument);
    } }, inputs: { sessionId: "sessionId", isEmbed: "isEmbed", displaySessionInfoHeader: "displaySessionInfoHeader", viewportHeight: "viewportHeight" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 11, vars: 6, consts: [[1, "olha-theme"], [1, "session-chat-container", 2, "overflow", "hidden", "position", "absolute", "left", "0", "right", "0", "height", "100%"], [1, "d-flex", "justify-content-center", "d-lg-none", "session-chat-header"], ["class", "col-12 col-lg-7 card m-0 p-0 switch-div", 4, "ngIf"], [1, "d-flex", "justify-content-center", "content-div"], ["class", "col-12 col-sm-12  px-0 chat-ui-part d-flex flex-column", 3, "ngClass", "ngStyle", 4, "ngIf"], ["class", "col-12 col-sm-12 col-md-10 col-lg-8 px-0 chat-ui-part d-flex flex-column", 3, "ngStyle", 4, "ngIf"], ["class", "d-none d-lg-block col-lg-4 px-0 chat-ui-part ml-3", 4, "ngIf"], ["sessionDoesNotExistModal", ""], [1, "col-12", "col-lg-7", "card", "m-0", "p-0", "switch-div"], ["type", "button", "jhiTranslate", "sessionChat.button.chat", 1, "btn", "chat-button", 3, "ngClass", "click"], ["type", "button", "jhiTranslate", "sessionChat.button.actionPlan", 1, "btn", "action-plan-button", 3, "ngClass", "click"], [1, "col-12", "col-sm-12", "px-0", "chat-ui-part", "d-flex", "flex-column", 3, "ngClass", "ngStyle"], ["chatContainer", ""], [1, "bg-1", "chat-ui-header", "session-chat-header"], ["sessionInfoContainer", ""], [3, "session", "sessionStartTime", "onActionPlan", "displaySessionInfoHeader", 4, "ngIf"], [3, "ngClass"], ["sessionRatingContainer", ""], [1, "your-session-started-header", "bg-1", "d-flex", "align-items-center", "justify-content-center"], [1, "rating-stars", "d-flex", "align-items-center", "justify-content-center", "mt-2", "mb-2"], ["type", "hidden", "readonly", "readonly", "name", "another-rating-stars-value", "value", "5", 1, "rating-value"], [1, "rating-stars-container"], ["class", "rating-star", 4, "ngFor", "ngForOf"], [1, "d-flex", "align-items-center", "justify-content-center", "ml-1"], [1, "feedback-text", 3, "jhiTranslate", "matTooltip", "matTooltipPosition", "matTooltipClass", "click"], [3, "ngStyle"], [3, "session", "displayingPastSession", "viewportHeight", "repliedMessage", "firstSessionMessageOutput"], ["messageSendContainer", ""], [3, "session", "maxCharacterSize", "messageToBeReplied", "focusIn", "focusOut", 4, "ngIf"], [3, "session", "sessionStartTime", "onActionPlan", "displaySessionInfoHeader"], [1, "rating-star"], ["icon", "star", 1, "star-icon", 3, "ngClass"], [3, "session", "maxCharacterSize", "messageToBeReplied", "focusIn", "focusOut"], [1, "col-12", "col-sm-12", "col-md-10", "col-lg-8", "px-0", "chat-ui-part", "d-flex", "flex-column", 3, "ngStyle"], [1, "action-plan-div-mobile"], ["class", "btn btn-primary book-follow-up d-lg-none", "routerLink", "/session/schedule-session", "jhiTranslate", "sessionChat.button.bookYourNext", 4, "ngIf"], ["showAll", "true", 3, "actionPlan"], ["routerLink", "/session/schedule-session", "jhiTranslate", "sessionChat.button.bookYourNext", 1, "btn", "btn-primary", "book-follow-up", "d-lg-none"], [1, "d-none", "d-lg-block", "col-lg-4", "px-0", "chat-ui-part", "ml-3"], ["class", "action-plan-header bg-1", "style", "border-radius: 10px!important;", 4, "ngIf"], [1, "action-plan-div-pc"], ["class", "btn btn-primary book-follow-up d-none d-lg-block", "routerLink", "/session/schedule-session", "jhiTranslate", "sessionChat.button.bookYourNext", 4, "ngIf"], [1, "action-plan-header", "bg-1", 2, "border-radius", "10px!important"], ["routerLink", "/session/schedule-session", "jhiTranslate", "sessionChat.button.bookYourNext", 1, "btn", "btn-primary", "book-follow-up", "d-none", "d-lg-block"], [3, "titleText", "message", "navigateTo"]], template: function SessionChatUserComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, SessionChatUserComponent_div_3_Template, 5, 2, "div", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, SessionChatUserComponent_div_5_Template, 20, 28, "div", 5);
        i0.ɵɵtemplate(6, SessionChatUserComponent_div_6_Template, 4, 5, "div", 6);
        i0.ɵɵtemplate(7, SessionChatUserComponent_div_7_Template, 5, 3, "div", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, SessionChatUserComponent_ng_template_8_Template, 2, 4, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelement(10, "jhi-alert");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("user-session-chat-container", !ctx.isEmbed);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.session);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.switchTo === "chat");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.switchTo === "action plan");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isEmbed);
    } }, directives: [i15.NgIf, i16.AlertComponent, i17.JhiTranslateDirective, i15.NgClass, i15.NgStyle, i15.NgForOf, i18.MatTooltip, i19.ChatUiNewComponent, i20.SessionInfoHeaderComponent, i21.FaIconComponent, i22.SessionMessageSendComponent, i23.ActionPlanComponent, i8.RouterLink, i24.ModalSuccessComponent], pipes: [i25.TranslatePipe], styles: ["body[_ngcontent-%COMP%]{background-color:var(--bg-2) !important}.user-session-chat-container[_ngcontent-%COMP%]{padding:60px 0 0;margin-left:0;margin-right:0;width:100%}.chat-container[_ngcontent-%COMP%]{height:calc(100% - 110px)}.chat-container-embed[_ngcontent-%COMP%]{height:calc(100% - 195px)}.content-div[_ngcontent-%COMP%]{height:calc(100% - 40px)}.chat-ui-part-coach[_ngcontent-%COMP%]{background-color:#fff;border:1px solid rgba(0,0,0,.1);border-radius:20px;padding:5px;min-height:100%;position:relative !important}.chat-ui-part[_ngcontent-%COMP%]{background-color:#fff !important;border:none !important;border-radius:0;min-height:100%;position:relative !important}.action-plan-header[_ngcontent-%COMP%]{margin:20px !important}.action-plan-div-mobile[_ngcontent-%COMP%]{overflow-y:scroll !important;overflow-x:hidden !important;margin:20px !important;max-height:100% !important}.action-plan-div-pc[_ngcontent-%COMP%]{overflow-y:scroll !important;overflow-x:hidden !important;margin:20px !important;max-height:calc(100% - 150px) !important}.chat-ui-header[_ngcontent-%COMP%]{border-radius:0}chat-ui-new[_ngcontent-%COMP%]{height:100% !important}.switch-div[_ngcontent-%COMP%]{display:grid;grid-auto-columns:minmax(0, 1fr);grid-auto-flow:column}.chat-button[_ngcontent-%COMP%]{min-width:100% !important;border:none !important;border-radius:0}.action-plan-button[_ngcontent-%COMP%]{min-width:100% !important;border:none !important;border-radius:0}.your-session-started-header[_ngcontent-%COMP%]{margin:8px 12px 12px 12px !important;border:none !important;border-radius:5px !important}.your-session-started-text[_ngcontent-%COMP%]{padding:20px !important;margin:0 !important;font-weight:600 !important}.session-started-header[_ngcontent-%COMP%]{margin:8px 12px 12px 12px !important}.session-started-text[_ngcontent-%COMP%]{padding:7px !important;margin:0 !important;font-weight:normal !important;font-size:12px !important;color:#8a9d98 !important}.session-started-header[_ngcontent-%COMP%]{margin:0 12px !important}.session-started-text[_ngcontent-%COMP%]{margin:0 !important;font-weight:normal !important;font-size:12px !important;color:#8a9d98 !important}.rating-stars[_ngcontent-%COMP%]   .rating-stars-container[_ngcontent-%COMP%]   .rating-star[_ngcontent-%COMP%]{font-size:22px !important;padding:0 6px !important;color:#fff}.rating-star-hover[_ngcontent-%COMP%]{color:#44a38d}.star-icon[_ngcontent-%COMP%]{stroke:#44a38b;stroke-width:2}.feedback-text[_ngcontent-%COMP%]{text-decoration:underline !important;color:#44a38b !important;cursor:pointer !important;font-size:14px !important;margin:0 !important}[_nghost-%COMP%] .feedback-tool-tip{color:#fff !important;background:#44a38b !important;border:1px solid #44a38b !important;overflow:visible !important}[_nghost-%COMP%]  .feedback-tool-tip:before{content:\"\";position:absolute;top:-11px;left:50%;border-bottom:10px solid #44a38b;border-left:10px solid transparent;border-right:10px solid transparent;z-index:10000}.back-home-text[_ngcontent-%COMP%]{text-decoration:underline !important;color:#44a38b !important;cursor:pointer !important;font-size:14px !important;margin:0 !important}.book-follow-up[_ngcontent-%COMP%]{position:absolute !important;bottom:30px !important;left:50% !important;transform:translateX(-50%);z-index:1000 !important}.chat-progress-bar-horizontal[_ngcontent-%COMP%]{border-radius:10px !important;background-color:#f8f7f2;height:23px;width:275px;margin-top:5px;z-index:0}.progress-bar-tough-place[_ngcontent-%COMP%]{border-radius:20px 0 0 20px !important;display:inline-block;z-index:10;background-color:#b894aa}.progress-bar-at-risk[_ngcontent-%COMP%]{border-radius:0 0 0 0 !important;display:inline-block;z-index:10;background-color:#efe199}.progress-bar-resilient[_ngcontent-%COMP%]{border-radius:0 20px 20px 0 !important;display:inline-block;z-index:10;background-color:#a9d3c7}.number-circle[_ngcontent-%COMP%]{width:20px;height:20px;margin:2px 2px 2px auto}.s-resilient[_ngcontent-%COMP%]{position:absolute;color:#000;margin-top:.7rem;top:0;z-index:20;left:78.5%}.s-at-risk[_ngcontent-%COMP%]{position:absolute;color:#000;margin-top:.7rem;top:0;z-index:20;left:37%}.s-in-a-bad-place[_ngcontent-%COMP%]{position:absolute;color:#000;margin-top:.7rem;top:0;z-index:20;left:4.5%}.session-summary-icons[_ngcontent-%COMP%]{color:#8a9d98;cursor:pointer;margin-right:20px;margin-top:20px}.session-summary-icons[_ngcontent-%COMP%]   fa-icon[_ngcontent-%COMP%]{padding-left:5px}[_nghost-%COMP%]  .tooltip-inner{background:#f7eed2;color:#0a4a3a;text-align:left;border-radius:5px}[_nghost-%COMP%]  .arrow::before{border-top-color:#f7eed2 !important}[_nghost-%COMP%]  .popover{max-width:70% !important}.chat-progress-bar-horizontal[_ngcontent-%COMP%]{width:220px}@media(min-width: 576px){.chat-progress-bar-horizontal[_ngcontent-%COMP%]{width:275px}  .popover{max-width:25rem !important}}@media(min-width: 768px){.chat-progress-bar-horizontal[_ngcontent-%COMP%]{width:275px}.session-started-header[_ngcontent-%COMP%]{margin:0 12px !important}.session-started-text[_ngcontent-%COMP%]{font-size:14px !important}.back-home-text[_ngcontent-%COMP%]{font-size:16px !important;margin:0 !important}  .popover{max-width:25rem !important}}@media(min-width: 992px){.content-div[_ngcontent-%COMP%]{height:100% !important}.chat-progress-bar-horizontal[_ngcontent-%COMP%]{width:275px}  .popover{max-width:25rem !important}.user-session-chat-container[_ngcontent-%COMP%]{padding-bottom:1.5rem;padding-top:80px;padding-left:15px;padding-right:15px;margin-left:auto;margin-right:auto}.chat-ui-part[_ngcontent-%COMP%]{border-radius:20px !important}.chat-ui-header[_ngcontent-%COMP%]{border-top-left-radius:inherit;border-top-right-radius:inherit}}@media(min-width: 1200px){.chat-progress-bar-horizontal[_ngcontent-%COMP%]{width:275px}  .popover{max-width:25rem !important}}"] });
